module.exports = __webpack_public_path__ + "static/peterclarkes-b287bd685f3b8218ff9594dd299ddde1.webp";